import { parseQuery } from '@utils/utils'
import { platform,PLATFORM } from '@utils/device/platform'


const searchParams = new URLSearchParams(location.search)
const urlQuery:any = parseQuery()

/**
 * @description 
 * @returns 版本号
 */
export const readAppVersion = ():string | null => {
  let appVersion: string | null = null

  switch (platform) {
    case PLATFORM.APP:
      // eslint-disable-next-line
      // const deviceInfo = JSON.parse(mfBridge.getAppDeviceInfo())
      // appVersion = deviceInfo.appVersion
      appVersion = searchParams.get('appVersion') || urlQuery.appVersion || ''
      break;
    case PLATFORM.WEB:
    case PLATFORM.WECHAT:
    case PLATFORM.WXAPP:
    default:
      appVersion = searchParams.get('appVersion') || urlQuery.appVersion || ''
  }

  return appVersion
}


